module.exports = __webpack_public_path__ + "img/Ignis 2023.6f171893.png";